import { TaskStoredValues, TaskStoredValuesDelegate } from "@ogaf/scripts/Modules/TaskStoredValues";
import * as moment from "moment";

export class PpdStoredValues extends TaskStoredValues {

    constructor(collectionName: string, collectionVersion: string, repairCollectionFunction: TaskStoredValuesDelegate = null, currentTask: TTaskBase = null) {
        super(collectionName, collectionVersion, repairCollectionFunction, currentTask);
    }

    public GetDateRange(startDateKey: string, endDateKey: string, dayCount: number = 7) {
        let startDateStoredVal: string = super.Get(startDateKey);
        let endDateStoredVal: string = super.Get(endDateKey);
        let dateRange: Array<string> = new Array(2);

        if (startDateStoredVal === "" || endDateStoredVal === "") {
            let endDate = moment().format('DD.MM.YYYY');
            let startDate = moment().add(-dayCount, 'd').format('DD.MM.YYYY');
            dateRange[0] = startDate;
            dateRange[1] = endDate;
        }
        else {
            dateRange[0] = startDateStoredVal;
            dateRange[1] = endDateStoredVal;
        }

        return dateRange;
    }

    public IsDefaultDateRange(startDateKey: string, endDateKey: string) {
        let startDateStoredVal: string = super.Get(startDateKey);
        let endDateStoredVal: string = super.Get(endDateKey);

        return startDateStoredVal === "" && endDateStoredVal === "";
    }

}